import React from 'react';
import { cn } from '../../lib/utils';

type StatusMessageProps = {
    message: string;
    type?: StatusMessageType;
} & React.ComponentPropsWithoutRef<'small'>;

export enum StatusMessageType {
    SUCCESS = 'success',
    ERROR = 'error',
    WARNING = 'warning',
    INFO = 'info',
}

const StatusMessage = React.forwardRef<HTMLElement, StatusMessageProps>(({ className, message, type, ...props }, ref) => {
    const classes = type === StatusMessageType.ERROR ? 'bg-red-700' : 'bg-active';

    return (
        <small className={cn('absolute -left-2 -top-3 text-white bg-primary px-2 rounded', classes, className)} ref={ref} {...props}>
            {message}

            <>
                <div className={cn('rounded-full w-3 h-3 bg-primary absolute -left-[2px] -top-[2px] animate-ping', classes)}></div>
                <div className={cn('rounded-full w-3 h-3 bg-primary absolute -left-[2px] -top-[2px]', classes)}></div>
            </>
        </small>
    );
});

StatusMessage.displayName = 'StatusMessage';

const Status = React.forwardRef<HTMLElement, StatusMessageProps>(({ className, message, type, ...props }, ref) => {
    return (
        <small
            className={cn('text-white bg-primary px-2 rounded bg-active', {
                'bg-red-700': type === StatusMessageType.ERROR,
                'bg-primary': type === StatusMessageType.INFO,
            })}
            ref={ref}
        >
            {message}
        </small>
    );
});

export { Status, StatusMessage };
